<template>
  <div id="app" style="margin-left: 1em; margin-right: 1em;">

    <nav class="navbar">
    <div class="navbar-container">
      <div><h1 class="navbar-title">Literarisches Feld DDR</h1>
        <h1 class="navbar-subtitle">Bio-bibliographische Datenexploration</h1></div>
      <ul class="navbar-menu">
        <li>
          <a class="navbar-links" href="https://ddr-literatur.de/data-exploration/#instructions" target="_blank">Nutzungshinweise</a>
        </li>
        <li>·</li>
        <li>
          <a class="navbar-links" href="https://plattform.ddr-literatur.de/imprint.html" target="_blank">Impressum</a>
        </li>
      </ul>
    </div>
  </nav>
    <div class="main-content">
      
    
    
    <!-- Forschungsplattform Literarisches Feld DDR
     #AL: ich finde mit dem Volltext, dass der Titel viel zu lang ist. -->
    <p class="app-disclaimer">Es handelt sich hier um einen Prototyp in einer frühen Entwicklungsphase, den wir öffentlich zugänglich machen, um <a href="mailto:exploration@ddr-literatur.de">Rückmeldungen</a> zu erhalten. Die Herausforderung liegt darin, dass wir möglichst viele Kombinationsmöglichkeiten von Abfragekriterien ohne größere Zugangsbarrieren, und insbesondere ohne Vorab-Formulierung von Abfragen, ermöglichen möchten. Die Oberfläche vermittelt dafür einen initialen Überblick über verschiedene Aspekte des Datenbestands, die jeweils als einzelne Grafiken dargestellt werden. Über direkte Interaktion mit den in den Grafiken visualisierten Daten kann dann die weitere Eingrenzung und Erschließung des Datenbestands erfolgen. Da der Umgang mit der von uns entwickelten Oberfläche zum jetzigen Zeitpunkt noch nicht unserem Anspruch auf Intuitivität entspricht, bieten wir Ihnen unter <a href="https://ddr-literatur.de/data-exploration/#instructions" target="_blank">Nutzungshinweise</a> ein Modell des Vorgehens an.</p>

    <!-- <h1>Exploration</h1> -->

    <div class="tabs sticky-tabs" key="tabs">
      <div class="tab" :class="{ active: selectedTab === 'PublicationsView' }" @click="selectTab('PublicationsView')">
        Publikationen
        <div class="btn-add-tab" :class="{ active: selectedTab === 'PublicationsView' }" @click="addView">+</div>
      </div>
      <div class="tab" :class="{ active: selectedTab === 'EventsView' }" @click="selectTab('EventsView')">
        Biographien
        <div class="btn-add-tab" :class="{ active: selectedTab === 'EventsView' }"  @click="addView">+</div>
      </div>
      <div v-for="tab in tabs" :key="tab.name" class="tab" :class="{ active: selectedTab === tab.name }" @click="selectTab(tab.name)">
        {{ tab.name }}
        <div class="btn-remove-tab" :class="{ active: selectedTab === tab.name }" @click="removeView(tab)" >x</div>
      </div>
    </div>
    
    <div class="tab-content" :key="viewKey">
      <keep-alive>
        <component :is="getComponent(selectedTab)"></component>
      </keep-alive>

    </div>
  </div>

  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { ref, defineComponent, createApp } from 'vue';
import EventsView from './components/EventsView.vue';
import PublicationsView from './components/PublicationsView.vue';
import { EventBus } from './lib/EventBus';
import {globalEventslog} from "@/lib/GlobalEventsLog";
import {EVENTS_TAB_LABEL, PUBLICATIONS_TAB_LABEL} from "@/lib/SharedConstants";


export default {
  components: {
    EventsView,
    PublicationsView
  },
  data() {
    return {
      viewKey: 0,
      tabs: [],
      selectedTab: 'PublicationsView', // default selected tab
    };
  },
  methods: {
    addView() {
      console.log("Tab is selected:", this.selectedTab);
      // TODO: DE-EN messed up: the problem is that here, we expect the names of one of the first two components (publications or events), which
      //  are given in English, i.e. we must not check for the new German names
      var tabName = this.selectedTab.startsWith("Publications") ? (PUBLICATIONS_TAB_LABEL) + "-" + (++this.additonalViewsCounters.publications) : EVENTS_TAB_LABEL + "-" + (++this.additonalViewsCounters.events);
      this.tabs.push({name: tabName, componentid: tabName.toLowerCase()});
      // it does not seem to be necessary to call selectTab here - as the new tab will not be selected anyway
      // this.selectTab(tabName);
      //this.updateLocalStorageTabs();
    },
    removeView(tab) {
      const index = this.tabs.findIndex(t => t.name === tab.name);
      if (index !== -1) {
        this.tabs.splice(index, 1);
        if (this.selectedTab === tab.name) {
          // If the removed tab is the currently selected tab, select the first tab
          this.selectTab(this.tabs.length > 0 ? this.tabs[0].name : 'PublicationsView');
        }
        // find out the component id for the tab
        // TODO: we currently manage the component ids twice: here AND in the respective component implementations
        //  but we have not found a way so far to access the component instance (the Proxy object created by Vue.js) given
        //  the component implementation (the values of the components map)
        const componentid = tab.componentid;
        console.log("removeView(): got componentid: ", componentid, this.componentsMap, tab);
        EventBus.emit('externalFilterTabRemoved', {
          componentid
        });
      }
      //this.updateLocalStorageTabs();
    },
    // for test mode, no need to use local storage
    /*updateLocalStorageTabs() {
      const tabNames = this.tabs.map(tab => tab.name);
      localStorage.setItem('openTabs', JSON.stringify(tabNames));
    },*/
    selectTab(tabName) {
      this.selectedTab = tabName;
    },
    getComponent(tabName) {
      // TODO: DE-EN messed up
      console.log("getComponent(): ", tabName, this.componentsMap)
      if ((tabName.startsWith(PUBLICATIONS_TAB_LABEL + "-") || (tabName.startsWith("Publications"))) && !this.componentsMap[tabName]) {
        // in order to create a new instance of a component, we only need to apply the spread-operator {... }...
        this.componentsMap[tabName] = {...PublicationsView};
      } else if ((tabName.startsWith(EVENTS_TAB_LABEL + "-") || tabName.startsWith("Events")) && !this.componentsMap[tabName]) {
        this.componentsMap[tabName] = {...EventsView};
      }
      return this.componentsMap[tabName] || null; // Return the component or null if not found
    },
    restoreTabsFromLocalStorage() {
      const tabNames = JSON.parse(localStorage.getItem('openTabs'));
      if (tabNames && Array.isArray(tabNames)) {
        tabNames.forEach(tabName => {
          this.tabs.push({ name: tabName, componentid: tabName.toLowerCase() });
        });
      }
    }
  },
  created() {
    document.title = "Forschungsplattform Literarisches Feld DDR - Datenexploration"

    this.restoreTabsFromLocalStorage();
    // Map the tab names to component names
    this.componentsMap = {
      'PublicationsView': 'PublicationsView',
      'EventsView': 'EventsView'
    };
    this.additonalViewsCounters = {
      publications: 1,
      events: 1
    }

    this.eventslog = [];

    EventBus.on('filteredPersons',eventpayload => {
      const eventdata = {componentid: eventpayload.componentid,filterState: Object.entries(eventpayload.filterState)
            .reduce((acc,[key,value]) => {
              acc[key] = value instanceof Set ? Array.from(value) : {...value};
              return acc;
            },{})};
      this.eventslog.push(eventdata);
      globalEventslog[eventpayload.componentid] = eventpayload;
      console.log("eventslog is: ", this.eventslog);
    });

    window.addEventListener('scroll', function() {
        const stickyTabs = document.querySelector('.tabs');
        // const navbar = document.querySelector('.navbar');
        const intro = document.querySelector('.app-disclaimer');

        const stickyStart = intro.offsetHeight;

        if (window.scrollY >= stickyStart) {
            stickyTabs.classList.add('stuck');
        } else {
            stickyTabs.classList.remove('stuck');
        }
    });
  },
  mounted() {
    console.log("App.mounted(): ", this, this.selectedTab, this.selectTab);
    this.selectTab("EventsView");
  },
  setup() {
    // console.log("App.setup(): ", this);
    // const selectedTab = ref('PublicationsView');
    // const selectTab = (tabName) => {
    //   selectedTab.value = tabName;
    // };
    //
    // return {
    //   selectedTab,
    //   selectTab,
    // };
  }
};
</script>
